var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[(_vm.type === 'china')?_c('div',{staticClass:"agent"},[_c('ChinaIpGoods')],1):_c('div',{staticClass:"agent"},[_c('AbroadIpGoods')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }